/* eslint-disable */
import requestRaw from "@/utils/requestRaw";
import request from "@/utils/request";
import requestDev from "@/utils/requestDev";
import { APICore, APIReportPHP } from "@/utils/servicesApi";
const qs = require("qs");

export function deleteAgentRolesOneStored(data) {
  return requestDev({
    url: APIReportPHP() + "/agent/delete-roles-one",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}
export function updateAgentRolesOneStored(data) {
  return requestDev({
    url: APIReportPHP() + "/agent/update-roles-one",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}
export function getAgentRel(data) {
  return requestDev({
    url: APIReportPHP() + "/agent/get-agent-rel",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}
export function updatePasswordStored(data) {
  return requestDev({
    url: APIReportPHP() + "/agent/update-agent-password",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}
export function updateStored(data) {
  return requestDev({
    url: APIReportPHP() + "/agent/update",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}
export function getAgentById(id) {
  return requestRaw({
    url: APICore() + "/agent/get-agent-by-id?id=" + id,
    method: "GET"
    // data: data // untuk array data post
  });
}
export function getAgentList(data) {
  return requestDev({
    url: APIReportPHP() + "/agent/list",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}
export function createStored(data) {
  return requestDev({
    url: APIReportPHP() + "/agent/create",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}

export function connectToAgentOwner(dataArr) {
  return requestDev({
    url:
      APIReportPHP() +
      "/omni/connect-to-agent-owner?agent_id=" +
      dataArr.agent_id,
    method: "GET"
    // data: data // untuk array data post
  });
}
export function getRoomList(data) {
  return request({
    url: APICore() + "/omni/room-list",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}
export function getHotChatList(data) {
  return request({
    url: APICore() + "/omni/hot-chat-list",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}

export function getColdChatList(data) {
  return request({
    url: APICore() + "/omni/cold-chat-list",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}

export function getTotalScrapeMP(params) {
  return requestDev({
    url: APIReportPHP() + "/omni/total-scrapemp",
    method: "POST",
    data: qs.stringify(params)
  });
}

export function getTotalScrapeStatus(params) {
  return requestDev({
    url: APIReportPHP() + "/omni/total-scrapestatus",
    method: "POST",
    data: qs.stringify(params)
  });
}

export function totalStatusPerMP(params) {
  return requestDev({
    url: APIReportPHP() + "/omni/total_status_per_mp",
    method: "POST",
    data: qs.stringify(params)
  });
}

export function totalKeywords(params) {
  return requestDev({
    url: APIReportPHP() + "/omni/calculate_keywords",
    method: "POST",
    data: qs.stringify(params)
  });
}

export function totalStatusShopee(params) {
  return requestDev({
    url: APIReportPHP() + "/omni/total_status_shopee",
    method: "POST",
    data: qs.stringify(params)
  });
}

export function totalStatusTokopedia(params) {
  return requestDev({
    url: APIReportPHP() + "/omni/total_status_tokopedia",
    method: "POST",
    data: qs.stringify(params)
  });
}

export function totalStatusLazada(params) {
  return requestDev({
    url: APIReportPHP() + "/omni/total_status_lazada",
    method: "POST",
    data: qs.stringify(params)
  });
}

export function totalStatusBukalapak(params) {
  return requestDev({
    url: APIReportPHP() + "/omni/total_status_bukalapak",
    method: "POST",
    data: qs.stringify(params)
  });
}

export function reportSummary(params) {
  return requestDev({
    url: APIReportPHP() + "/omni/report_summary",
    method: "POST",
    data: qs.stringify(params)
  });
}



// WEBPACK FOOTER //
// ./src/api/agent.js